var root;

$(function () {
    // run js if Chrome is being used - fix for the parallel banners for chrome
    if ('WebkitAppearance' in document.documentElement.style) {
        // fix webkit bug with background-attachment:fixed and transform applied, only first banner will be fixed.
        $(".w-slider-mask .banner:not(:first)").css('background-attachment', 'scroll');
    }
    root = $('body').data('root');
    InitPage();  
});

$(window).load(function () {
    // initialise page
    $('[data-remodal-id=modal]').remodal();

    $.scrollUp({
        scrollImg: true, // Set true to use image
    });
    $("img.lazy").each(function () {
        $(this).attr("src", $(this).attr("data-original")).fadeIn('slow');
        $(this).removeAttr("data-original");
    });
    //add data attributes to banner text
    $('.big-title-banner').data("ix", "fade-in-big-title-on-load");
    $('.sub-text-title').data("ix", "fade-in-sub-text-title-on-load");

    // site search handler - brochure
    $('#site-search-tbx').keypress(function (e) {
        if (e.which == 13) {
            $('#site-search-btn').click();
        }
    });
    $('#site-search-btn').click(function () {
        if ($('#site-search-tbx').val() != "") {
            var str = $('#site-search-tbx').val();
            window.location.href = root + "/Home/SiteSearch?s=" + str;
        }
        return false;
    });

    // product search handler
    $("#prod-search-tbx").autocomplete({
        source: root + '/Products/AutoComplete',
        minLength: 2,
        select: function (event, ui) {
            window.location.href = ui.item.url;
        }
    });
    $('#prod-search-tbx').keypress(function (e) {
        if (e.which == 13) {
            $('#prod-search-btn').click();
        }
    });
    $('#prod-search-btn').click(function () {
        if ($('#prod-search-tbx').val() != "") {
            var str = $('#prod-search-tbx').val();
            window.location.href = root + "/Products/Search/" + str;
        }
        return false;
    });

    // bag handler
    $('#bag-opener').click(function () {
        SlideTopCart();
        return false;
    });
    //add data attributes to banner text
    $('.big-title-banner').data("ix", "fade-in-big-title-on-load");
    $('.sub-text-title').data("ix", "fade-in-sub-text-title-on-load");

    $('.manualItem h2 a').addClass("videoPopBtn");
    // popup for videos
    //$('.videoPopBtn').magnificPopup({
    //    type: 'iframe'
    //     other options
    //});
    // Zoom page - conforms to WCAG20 - http://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast-scale.html
    // Set initial zoom level
    var zoom_level = 100;
    $('.increaseFont').click(function () { zoom_page(10, $(this)); return false; });
    $('.decreaseFont').click(function () { zoom_page(-10, $(this)); return false; });
    $('.resetFont').click(function () { zoom_page(0, $(this)); return false; });

    // Zoom function
    function zoom_page(step, trigger) {
        // Zoom just to steps in or out
        if (zoom_level >= 120 && step > 0 || zoom_level <= 80 && step < 0) return;

        // Set / reset zoom
        if (step == 0) zoom_level = 100;
        else zoom_level = zoom_level + step;

        // Set page zoom via CSS
        $('body').css({
            transform: 'scale(' + (zoom_level / 100) + ')', // set zoom
            transformOrigin: '50% 0' // set transform scale base
        });

        // Adjust page to zoom width
        if (zoom_level > 100) $('body').css({ width: (zoom_level * 1.2) + '%' });
        else $('body').css({ width: '100%' });

        scrollTo(($(document).width() - $(window).width()) / 2, 0);

        // Activate / deaktivate trigger (use CSS to make them look different)
        if (zoom_level >= 120 || zoom_level <= 80) trigger.addClass('disabled');
        else trigger.parents('ul').find('.disabled').removeClass('disabled');
        if (zoom_level != 100) $('#zoom_reset').removeClass('disabled');
        else $('#zoom_reset').addClass('disabled');
    }
    $(function () {
        setTheme = function (colourScheme) {
            if ((colourScheme != "Default") && (colourScheme != "Default")) {
                if (colourScheme == "LightYellow") {
                    var fontColour = "black";
                    var backgroundColour = "lightyellow"
                }
                if (colourScheme == "LightBlue") {
                    var fontColour = "darkblue";
                    var backgroundColour = "lightblue"
                }
                if (colourScheme == "LightGrey") {
                    var fontColour = "black";
                    var backgroundColour = "lightgrey"
                }
                if (colourScheme == "DarkGrey") {
                    var fontColour = "black";
                    var backgroundColour = "darkgrey"
                }
                if (colourScheme == "HiViz") {
                    var fontColour = "white";
                    var backgroundColour = "black"
                }
                if (colourScheme == "LightYellow") {
                    var fontColour = "black";
                    var backgroundColour = "lightyellow"
                }
                if (colourScheme == "Default") {
                    var fontColour = null;
                    var backgroundColour = null
                }
                $("h1, h2, h3, p, a, li, body, div.p, div.w-dropdown-toggle").css({

                    'color': fontColour,
                    'background-color': backgroundColour
                });
                setCookie("theme", colourScheme, 30);
                //alert(getCookie("theme"));
            }
            else {
                setCookie('theme', null, 30);
                location.reload();
            }
        }
        var theme = getCookie("theme");
        //alert(theme);
        setTheme(theme);
        var pageID = "1";
        var parentID = "";
        $("#" + pageID).children().css({ "font-weight": "bold", "text-decoration": "underline" });
        $("#" + parentID).children().css({ "font-weight": "bold", "text-decoration": "underline" });

        function setCookie(c_name, value, exdays) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + exdays);
            var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString() + "; path=/");
            document.cookie = c_name + "=" + c_value;
        }
        function getCookie(c_name) {
            var c_value = document.cookie;
            var c_start = c_value.indexOf(" " + c_name + "=");
            if (c_start == -1) {
                c_start = c_value.indexOf(c_name + "=");
            }
            if (c_start == -1) {
                c_value = null;
            }
            else {
                c_start = c_value.indexOf("=", c_start) + 1;
                var c_end = c_value.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = c_value.length;
                }
                c_value = unescape(c_value.substring(c_start, c_end));
            }
            return c_value;
        }
        function deleteCookie(name) {
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            location.reload();
        };
    });
});


// functions
function InitPage() {
    $('#top-cart-holder').hide();
    SetCartQty();
    GetTopCart();
}

function GetTopCart() {
    $.post(root + '/Cart/TopCart', null, function (data) {
        $('#top-cart-holder').empty();
        $(data).appendTo('#top-cart-holder');
    });
}

function SlideTopCart() {
    if ($('#top-cart-holder').is(':hidden')) {
        $('#top-cart-holder').slideDown();
    }
    else {
        $('#top-cart-holder').slideUp();
    }
}

function GetAndOpenTopCart() {
    GetTopCart();
    if ($('#top-cart-holder').is(':hidden')) {
        $('#top-cart-holder').slideDown();
    }
}

function SetCartQty() {
    $.post(root + "Cart/GetNumCartItems", function (data) {
        if (data.result == "ok") {
            if (data.qty == 1) {
                $('.cart-total-qty').html(data.qty + " Item");
            }
            else {
                $('.cart-total-qty').html(data.qty + " Items");
            }
        }
    });
}

function RegisterRsp(data) {
    if (data.result == "ok") {
        $('[data-remodal-id=modal]').remodal().open();
        $('#signup-tbx').val('');
    }
    else {
        $(".errorMessage").html(data.result);
        $("#emailError").remodal().open();

    }

}
function emailNotCorrect(data) {
    $('#emailNotCorrect').remodal().open();
}
